import React from 'react';
import {
  Box,
  Flex,
  Text,
  Heading,
  VStack,
  Icon,
  useColorModeValue,
} from '@chakra-ui/react';
import { MdSettings, MdCheckCircle } from 'react-icons/md';

const OnboardingOverlay = ({ isVisible, onboardingStatus }) => {
  // All hooks must be called before any early returns
  const overlayBg = useColorModeValue('rgba(255, 255, 255, 0.95)', 'rgba(26, 32, 44, 0.95)');
  const cardBg = useColorModeValue('white', 'gray.800');
  const textColor = useColorModeValue('gray.700', 'white');
  const brandColor = useColorModeValue('brand.500', 'brand.400');
  const shadowColor = useColorModeValue('0px 18px 40px rgba(112, 144, 176, 0.12)', 'unset');
  const stepBg = useColorModeValue('gray.50', 'gray.700');
  const infoTextColor = useColorModeValue('gray.600', 'gray.300');
  const borderColorValue = useColorModeValue('gray.200', 'gray.600');

  if (!isVisible) {
    return null;
  }

  const getStatusMessage = () => {
    switch (onboardingStatus) {
      case 100: // PENDING_SETUP
        return {
          title: 'ברוכים הבאים ל-Payro!',
          message: 'Payro צריך להשלים את תהליך ההרשמה שלכם ולהתחבר לנתוני השכר והנוכחות שלכם. אנחנו ניצור איתכם קשר בקרוב בנוגע לכך.',
          icon: MdSettings,
          iconColor: 'orange.400'
        };
      case 200: // SETUP_IN_PROGRESS
        return {
          title: 'מתקינים את המערכת עבורכם',
          message: 'הצוות שלנו עובד כעת על הגדרת החיבור לנתוני השכר והנוכחות שלכם. התהליך יושלם בקרוב.',
          icon: MdSettings,
          iconColor: 'blue.400'
        };
      default:
        return {
          title: 'מתקינים את המערכת עבורכם',
          message: 'Payro צריך להשלים את תהליך ההרשמה שלכם ולהתחבר לנתוני השכר והנוכחות שלכם. אנחנו ניצור איתכם קשר בקרוב בנוגע לכך.',
          icon: MdSettings,
          iconColor: 'orange.400'
        };
    }
  };

  const statusInfo = getStatusMessage();

  return (
    <Box
      position="fixed"
      top="0"
      left="0"
      right="0"
      bottom="0"
      bg={overlayBg}
      backdropFilter="blur(8px)"
      zIndex="9999"
      display="flex"
      alignItems="center"
      justifyContent="center"
      p={{ base: '20px', md: '40px' }}
    >
      <Box
        bg={cardBg}
        borderRadius="20px"
        boxShadow={shadowColor}
        p={{ base: '30px', md: '50px' }}
        maxW="600px"
        w="100%"
        textAlign="center"
        border="1px solid"
        borderColor={borderColorValue}
      >
        <VStack spacing="30px">
          {/* Icon */}
          <Flex
            w="80px"
            h="80px"
            borderRadius="50%"
            bg={stepBg}
            align="center"
            justify="center"
          >
            <Icon
              as={statusInfo.icon}
              w="40px"
              h="40px"
              color={statusInfo.iconColor}
            />
          </Flex>

          {/* Title */}
          <Heading
            fontSize={{ base: '24px', md: '32px' }}
            fontWeight="700"
            color={textColor}
            lineHeight="1.2"
            fontFamily="'Noto Sans Hebrew', sans-serif"
          >
            {statusInfo.title}
          </Heading>

          {/* Message */}
          <Text
            fontSize={{ base: '16px', md: '18px' }}
            color={textColor}
            lineHeight="1.6"
            fontFamily="'Noto Sans Hebrew', sans-serif"
            maxW="500px"
          >
            {statusInfo.message}
          </Text>

          {/* Additional info */}
          <Box
            bg={stepBg}
            borderRadius="12px"
            p="20px"
            w="100%"
          >
            <Text
              fontSize="14px"
              color={infoTextColor}
              fontFamily="'Noto Sans Hebrew', sans-serif"
            >
              בינתיים, תוכלו לראות את הממשק הבסיסי של המערכת ברקע. הגישה המלאה תהיה זמינה לאחר השלמת ההתקנה.
            </Text>
          </Box>
        </VStack>
      </Box>
    </Box>
  );
};

export default OnboardingOverlay;
